export const environment = {
  production: true,
  apiUrl: 'https://mydelivery.emea.fedex.com/pckapi',
  znrpoApiUrl: 'https://poland.fedex.com/fds2-retailpoints/rpo-v1',
};
// export const environment = {
//   production: false,
//   apiUrl: 'http://bregenz.omecon.pl:9092/pckapi',
//   znrpoApiUrl: 'https://dev-fedex-fdx.omecon.pl/api/znrpo',
// };
